export default "__VITE_ASSET__Dvvde_68__"